import { NothingToShow } from '@components/NothingToShow';
import { SummaryProvider, SummaryProviderProps } from '@components/SummarySelection/context';
import { SummaryStateType } from '@components/SummarySelection/data/summaryState';
import { CategoryType } from '@model/Category';
import { createMemo } from '@packages/react';
import React from 'react';
import { SummaryData } from './SummaryData';

type SummarySelectionProps = SummaryProviderProps & {
    category: number | CategoryType;
    isDR?: boolean;
    showPrices?: boolean;
    noBar?: boolean;
    noPackages?: boolean;
    radio?: boolean;
    customerId?: number;
    children?: any;
    onAdd?: (data: any) => void;
    config?: Pick<
        SummaryStateType,
        | 'withSkus'
        | 'withProducts'
        | 'skuTransformData'
        | 'categoryTransformData'
        | 'packageTransformData'
        | 'skuPrepareConfig'
        | 'categoryPrepareConfig'
        | 'packagePrepareConfig'
    >;
};

export const SummarySelection = createMemo<SummarySelectionProps>(
    (props) => {
        const {
            category,
            noBar,
            noPackages,
            showPrices,
            isDR,
            customerId,
            onAdd,
            radio,
            config,
            hideSizingKitItem,
            children,
            ...rest
        } = props;

        if (!category) {
            return <NothingToShow text={"There's no category selected!"} padding={'14px 0 0 0'} />;
        }

        const category_id = typeof category === 'number' ? category : category.id;
        const customer_id = customerId || undefined;

        rest.value = {
            ...rest.value,
            category_id,
            customer_id,
            radio,
            noBar,
            withProducts: !noPackages,
            showPrices,
            onAdd,
            isDR,
            ...config,
        };

        return (
            <SummaryProvider {...rest}>
                <SummaryData
                    category={category_id}
                    hideSizingKitItem={hideSizingKitItem}
                    showPrices={showPrices}
                    isDR={isDR}
                />
                {children}
            </SummaryProvider>
        );
    },
    { displayName: 'SummarySelection' },
);
